module.exports = __webpack_public_path__ + "static/img/error404.7eb1838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error404.png
// module id = IsV0
// module chunks = 1